import React, { Component } from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import Helmet from 'react-helmet';
import 'react-day-picker/lib/style.css';
import { Button, Popup } from 'semantic-ui-react';

export default class MasterFilterDateSelect extends Component<
    {
        clientId: Guid,
        filterType: string,
        displayName: string,
        onRemove: (filterType: string) => void,
        onSetDateRange: (filterType: string, from: Date, to: Date) => void,
        fromInitialValue: Date,
        toInitialValue: Date,
    },
    {
        from: Date,
        to: Date,
    }
> {
    constructor(props) {
        super(props);
        this.state = {
            from: new Date(this.props.fromInitialValue),
            to: new Date(this.props.toInitialValue),
        };
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleResetClick = this.handleResetClick.bind(this);
    }
    resetState() {
        return {
            from: undefined,
            to: undefined,
        };
    }
    handleResetClick() {
        this.setState(this.resetState());
    }
    handleDayClick(day) {
        const range = DateUtils.addDayToRange(day, this.state);
        this.setState(range);
        this.props.onSetDateRange(this.props.filterType, range.from, range.to);
    }
    render() {
        const { from, to } = this.state;
        const modifiers = { start: from, end: to };
        return (
            <div style={{ marginTop: '25px' }}>
                <div style={{ fontWeight: 'bold' }}>
                    <Popup
                        content="Remove this filter type from your selected list"
                        basic
                        trigger={
                            <Button
                                className="ui circular icon button"
                                onClick={() => this.props.onRemove(this.props.filterType)}
                            >
                                <i aria-hidden="true" className="minus icon"></i>
                            </Button>
                        }
                    />
                    {this.props.displayName} Filter
                </div>

                <div className="RangeExample">
                    <p>
                        {!from && !to && 'Please select the first day.'}
                        {from && !to && 'Please select the last day.'}
                        {from &&
                            to &&
                            `Selected from ${from.toLocaleDateString()} to
                                ${to.toLocaleDateString()}`}{' '}
                        {from && to && (
                            <Button className="link" onClick={this.handleResetClick}>
                                Reset
                            </Button>
                        )}
                    </p>
                    <DayPicker
                        className="Selectable"
                        numberOfMonths={2}
                        selectedDays={[from, { from, to }]}
                        modifiers={modifiers}
                        month={from}
                        onDayClick={this.handleDayClick.bind(this)}
                    />
                    <Helmet>
                        <style>
                            {`
  .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: #f0f8ff !important;
    color: #4a90e2;
  }
  .Selectable .DayPicker-Day {
    border-radius: 0 !important;
  }
  .Selectable .DayPicker-Day--start {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }
  .Selectable .DayPicker-Day--end {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
`}
                        </style>
                    </Helmet>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/molecules/MasterFilterDateSelect.jsx